var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M253.5,120.5L72.5,13.4c-14.7-8.7-37.2-0.3-37.2,21.2v214.1c0,19.3,20.9,30.9,37.2,21.2l181.1-107\n\tC269.7,153.4,269.8,130,253.5,120.5L253.5,120.5z"}));
}

Play.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
